export const getImageNames = (maximumImage: number) =>
  Array(maximumImage)
    .fill(0)
    .map((_, i) => `image${i + 1}`);
